import moment from "moment";
import { createSlice } from "@reduxjs/toolkit";
import AuthHelper from "components/auth/helpers";

type TimeOutStateType = {
  expiryDescription: string;
  isRunning: boolean;
  showPrompt: boolean;
};

const TimeOutStateInit: TimeOutStateType = {
  expiryDescription: moment().format(),
  isRunning: false,
  showPrompt: false
};

export const LoginTimeOutSlice = createSlice({
  name: "user-login-session-timeout-timer",
  initialState: TimeOutStateInit,
  reducers: {
    initTimer: (state, action) => {
      localStorage.setItem(AuthHelper.SESSION_EXPIRE_TIME, action.payload);
      localStorage.setItem(AuthHelper.TOKEN_EXPIRE_TIME, action.payload);
    },
    resetTimer: state => {
      (state.expiryDescription =
        "Expire time: " + localStorage.getItem(AuthHelper.SESSION_EXPIRE_TIME)),
        (state.isRunning = true),
        (state.showPrompt = false);
    },
    showAlert: state => {
      state.showPrompt = true;
    },
    setShouldShowPrompt: (state, action) => {
      state.showPrompt = action.payload;
    },
    afterExpiry: state => {
      state.showPrompt = false;
      state.isRunning = false;
    }
  }
});

export const { initTimer, resetTimer, setShouldShowPrompt, afterExpiry } =
  LoginTimeOutSlice.actions;
export default LoginTimeOutSlice.reducer;
